export class Enum<T> {
  public constructor(public readonly value: T) {}

  public toString() {
    return this.value.toString();
  }
  public getValue(): T {
    return this.value;
  }
}
